import React from "react";

const ConnectToCalendarButtons = ({ onConnectToCalendar }) => {
  return (
    <div className="w-full flex flex-col md:flex-row gap-2">
      <ConnectToCalendarButton
        text="Connect to Google Calendar"
        icon="/assets/icons/common/google-calendar.svg"
        className="border-[#006BFF] text-[#006BFF] hover:text-white hover:bg-[#006BFF]"
        onClick={() => onConnectToCalendar("google", "new")}
      />
      <ConnectToCalendarButton
        text="Connect to Outlook Calendar"
        icon="/assets/icons/common/outlook-calendar.svg"
        className="border-[#003F87] text-[#003F87] hover:text-white hover:bg-[#003F87] "
        onClick={() => onConnectToCalendar("microsoft", "new")}
      />
    </div>
  );
};

const ConnectToCalendarButton = ({ text, icon, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex flex-row gap-2 justify-start items-center border ${className} transition-all duration-300 hover:opacity-70 text-semibold text-[10px] md:text-[12px] lg:text-[14px] rounded-[4px] px-2 py-1`}
    >
      <img src={icon} alt={text} className="size-5" />
      <span>{text}</span>
    </button>
  );
};

export default ConnectToCalendarButtons;
